<template> 
  <div class="billboard px-3 pt-4">
    <GenericCarousel>
      <a :href="item.url" v-for="item in items" :key="item.url">
        <img :src="item.image_url" class="img-carousel" />
      </a>
    </GenericCarousel>
  </div>
</template>

<script>
import GenericCarousel from '@/components/carousel/GenericCarousel'

export default {
  components: {
    GenericCarousel,
  },
  
  props: {
    items: {
      type: Array, required: true,
    }
  },
};
</script>

<style scoped>
  .billboard {
    margin-bottom: 80px;
  }
  .img-carousel {
    border-radius: 8px;
    max-width: 100%;
    width: auto;
  }
</style>
